module.exports = __webpack_public_path__ + "./img/VendedoresInicio.655ffa70326794d9b1a67afc5c472322.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/VendedoresInicio.png
// module id = ./public/img/Help/VendedoresInicio.png
// module chunks = 0